import styled from 'styled-components';
import Link from './Link';
import { Flex } from './Flex';

const CardContainer = styled.div`
  && {
    background-color: ${({ theme }) => theme.colors.neutrals[7]};
    height: 80px;
    width: 320px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-radius: 1px;
    justify-content: space-evenly;
    margin-right: 20px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.blacks[2]};
      cursor: pointer;
    }

    svg {
      font-size: 48px;
      color: ${({ theme }) => theme.colors.whites[2]};
    }
  }
`;

const Title = styled.div`
  text-transform: capitalize;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  color: white;
`;

const SubTitle = styled.div`
  margin-top: 4px;
  opacity: 0.5;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: white;
`;

/**
 *
 * @param root0
 * @param root0.title
 * @param root0.subtitle
 * @param root0.icon
 * @param root0.to
 * @param root0.redirectPath
 * @param root0.redirect
 */
export default function EmptyCard({
  title,
  subtitle,
  icon,
  to,
  redirectPath,
  redirect,
}) {
  return (
    <Link href={to} redirectPath={redirectPath} redirect={redirect}>
      <CardContainer>
        <Flex flexDirection="column" justifyContent="center">
          <Title data-testid="empty-card-title">{title}</Title>
          <SubTitle data-testid="empty-card-subtitle">{subtitle}</SubTitle>
        </Flex>
        {icon}
      </CardContainer>
    </Link>
  );
}
